import { apiSlice } from '../../api/apiSlice';
import { DashboardParams } from '../dashboardTypes';
import { serializeQueryParams } from '../index';
import { InUseSimsTotalResponse } from './inUseSimsTotalApiSliceTypes';

const inUseSimsTotalApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getInUseSimsTotal: builder.query<
            InUseSimsTotalResponse,
            DashboardParams
        >({
            query: (params) => ({
                url: `/dashboard/in-use-sims-total?${serializeQueryParams(params)}`,
                method: 'GET',
                headers: {
                    'Accept-Language': params.acceptLanguage ?? 'en',
                },
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetInUseSimsTotalQuery, useLazyGetInUseSimsTotalQuery } =
    inUseSimsTotalApiSlice;
